import { render, staticRenderFns } from "./ResultsTable.vue?vue&type=template&id=496a6518&scoped=true"
import script from "./ResultsTable.vue?vue&type=script&lang=ts"
export * from "./ResultsTable.vue?vue&type=script&lang=ts"
import style0 from "./ResultsTable.vue?vue&type=style&index=0&id=496a6518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496a6518",
  null
  
)

export default component.exports